<template>
  <div class="layout-col">
    <section class="-wrapper-tile -wrapper-column -h-center-">
      <div class="-header">
        <div v-if="'AM'=== userInfo.auth">
          <p class="-h2 -font-weight-medium">

            {{ $t('pages_dashboard_before_month_total_used_amount.title')}}
            <g-tooltip-wrapper>
              <g-icon name="info" color="lightgray-4" class="-ml-1"></g-icon>
              <g-tooltip direction="right">
                <span v-html="$t('pages_dashboard_before_month_amount.tooltip')" />
              </g-tooltip>
            </g-tooltip-wrapper>
          </p>
        </div>
        <div v-else>
          <p class="-h2 -font-weight-medium">
            {{ $t('pages_dashboard_before_month_total_used_amount.title.AM')}}
            <g-tooltip-wrapper>
              <g-icon name="info" color="lightgray-4" class="-ml-1"></g-icon>
              <g-tooltip direction="right">
                <span v-html="$t('pages_dashboard_before_month_amount.tooltip')" />
              </g-tooltip>
            </g-tooltip-wrapper>
          </p>
        </div>


      </div>
      <div class="-wrapper --wrapper-between -width-100 -px-5 -pt-8 -pb-4 -height-dashboard-1 nowrap-">
        <div class="-wrapper-column between- -height-100 -mr-8 -pb-4">
          <div class="-wrapper -width-100 end-">
            <p id="dashboard-used-amount-total" class="-number l-"> {{ amount | comma }} <span class="-font-size-14 -font-weight-medium"></span></p>
          </div>
          <div class="-wrapper">
            <div class="-wrapper between- -width-100 -flex-grow-0 -mb-1">
              <p class="-color-gray-1 -font-size-12">{{ $t('pages_dashboard_before_month_total_used_amount.before_rate') }}</p>
              <p class="-wrapper v-center- -color-green-1 -font-size-12">
                <span id="dashboard-used-amount-arrow" class="material-icons -font-size-16">{{ arrow }}</span>
                <span id="dashboard-used-amount-rate"><span class="-font-family-special">{{ rate }}</span>%</span>
              </p>
            </div>
            <div class="-wrapper between- -width-100 -flex-grow-0 -mt-1">
              <p class="-color-gray-1 -font-size-12 -flex-grow-1 -ellipsis" style="flex: 11">{{ $t('pages_dashboard_before_month_total_used_amount.before_amount') }}</p>
              <p class="-wrapper v-center- -font-size-12 " style="text-align: right">
                <span id="dashboard-used-amount-cost" style="width: 95px"><span class="-font-family-special">{{ difference | comma }}</span>{{ $t('pages_dashboard_total_cost_preview_month.currency') }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="-wrapper-column v-h-center- -height-100 -pb-4">
          <total-cost-prev-month-am-chart
            id="dashboard-used-amount-chart"
            refName="usageCostAndPaymentStatusChart"
            :chart-data="chartData"
            :filter="filter"
            :stacked="false"
            :series-type="seriesType"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {AUTH_GROUP, CURRENCY_SYMBOL} from "@/constants/constants";
import TotalCostPrevMonthAmChart from "./components/TotalCostPrevMonthAmChart";

export default {
  name: 'total-cost-prev-month',
  componentName: 'TotalCostPrevMonth ',
  components: {TotalCostPrevMonthAmChart},
  data () {
    return {
      param : {},
      AUTH_GROUP : AUTH_GROUP,
      amount : '0',
      filter : [],
      arrow : '',
      beforeMonthUsedAmount : '',
      rate : '0',
      difference: '0',
      chartData : []
    }
  },
  computed: {
    ...mapGetters('dashboard', ['beforeUsedAmount', 'customerList']),
    ...mapGetters('user', ['userInfo']),
    seriesType () {
      return this.isLineGraph ? 'LineSeries' : 'ColumnSeries'
    }
  },
  methods: {
    ...mapActions('dashboard', ['getBeforeMonthUsedAmount', 'selectBeforeMonthContractTop', 'selectBeforeMonthProductsTop'])
  },
  watch : {
    beforeUsedAmount() {
      if(this.beforeUsedAmount.data){
        this.amount = this.beforeUsedAmount.data.month === '' ? 0 : this.beforeUsedAmount.data.month
        this.difference = this.beforeUsedAmount.data.month - this.beforeUsedAmount.data.beforeMonth == '' ? 0 : this.beforeUsedAmount.data.month - this.beforeUsedAmount.data.beforeMonth
        if(this.difference !== 0){
          this.rate = Math.round((this.beforeUsedAmount.data.month - this.beforeUsedAmount.data.beforeMonth) / this.beforeUsedAmount.data.month * 100 )
        }else{
          this.rate = 0
        }

        this.arrow = this.rate > 0 ? 'arrow_upward' : this.rate == 0 ? '' : 'arrow_downward'
        this.chartData = this.beforeUsedAmount.chart

      }
    }

  },
  mounted() {
    this.filter = [{label: this.$t('pages_dashboard_total_cost_preview_month.before_month'), column: 'beforeMonth'}
                  ,{label: this.$t('pages_dashboard_total_cost_preview_month.this_month'), column: 'month'}]
    if(this.userInfo.auth === AUTH_GROUP.AccountManager){
      this.param.customerDepts = [{ customerCode : this.userInfo.customerCode, deptCode : this.userInfo.customerDeptCode, checked : true }]
      this.getBeforeMonthUsedAmount(this.param)
      this.selectBeforeMonthContractTop(this.param)
      this.selectBeforeMonthProductsTop(this.param)
    }else if(this.userInfo.auth === AUTH_GROUP.BespinSales){
      this.param.customerDepts = this.customerList
      this.param.empNo = this.userInfo.empNo
    }else {
      this.param.customerDepts = this.customerList
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/components/TotalCostPrevMonth.vue